import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const ExitIconIntRev: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "23"}
      height={height ?? "24"}
      viewBox="0 0 23 24"
      fill="none"
      style={{ color: finalColor }}
    >
      <path
        d="M21.5489 12.7327H7.99723C7.58223 12.7327 7.24609 12.3966 7.24609 11.9816C7.24609 11.5666 7.58223 11.2305 7.99723 11.2305H21.5489C21.9639 11.2305 22.3001 11.5666 22.3001 11.9816C22.3001 12.3966 21.9639 12.7327 21.5489 12.7327Z"
        fill="currentColor"
      />
      <path
        d="M17.9288 16.4219C17.7367 16.4219 17.5445 16.3486 17.3974 16.2021C17.1039 15.9086 17.1039 15.4335 17.3974 15.1399L21.0554 11.4819C21.349 11.1883 21.8241 11.1883 22.1177 11.4819C22.4112 11.7755 22.4112 12.2506 22.1177 12.5441L18.4597 16.2021C18.3132 16.3486 18.1204 16.4219 17.9282 16.4219H17.9288Z"
        fill="currentColor"
      />
      <path
        d="M21.5869 12.7402C21.3947 12.7402 21.2025 12.667 21.0554 12.5205L17.3974 8.86248C17.1039 8.56892 17.1039 8.09382 17.3974 7.80025C17.691 7.50669 18.1667 7.50669 18.4597 7.80025L22.1177 11.4583C22.4112 11.7518 22.4112 12.2269 22.1177 12.5205C21.9712 12.667 21.779 12.7402 21.5862 12.7402H21.5869Z"
        fill="currentColor"
      />
      <path
        d="M10.8295 24.0003C10.2668 24.0003 9.70403 23.8557 9.20202 23.5659L1.62746 19.1924C0.623442 18.6128 0 17.5324 0 16.3738V7.62683C0 6.46758 0.623442 5.38782 1.62746 4.8082L9.20202 0.434719C10.206 -0.144906 11.4529 -0.144906 12.4569 0.434719L16.9587 3.03364C17.318 3.24083 17.4413 3.70028 17.2335 4.05957C17.0263 4.41886 16.5669 4.54155 16.2076 4.33436L11.7058 1.73543C11.1656 1.42309 10.494 1.42309 9.95316 1.73543L2.37859 6.10891C1.83778 6.42126 1.50227 7.00276 1.50227 7.62683V16.3732C1.50227 16.9972 1.83778 17.5787 2.37859 17.8911L9.95316 22.2646C10.494 22.5769 11.1656 22.5769 11.7058 22.2646L16.2076 19.6656C16.5669 19.4585 17.0263 19.5811 17.2335 19.9404C17.4407 20.2997 17.318 20.7592 16.9587 20.9664L12.4569 23.5653C11.9549 23.8551 11.3922 23.9997 10.8295 23.9997V24.0003Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ExitIconIntRev;
